import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import HighSchoolService from "../../src/Services/HighSchool.service";
import LookupGeneric from "./lookupGeneric";
const HighSchoolLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'number[]'.
            return HighSchoolService.findAllById(ids);
        },
        fetchOptions: (query) => {
            return HighSchoolService.search({
                query,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(highSchool) {
            return _jsx("span", { children: highSchool.name });
        },
    });
};
export default HighSchoolLookup;
